'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UITag;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _LightColors = require('../core/LightColors');

var _LightColors2 = _interopRequireDefault(_LightColors);

var _MediumColors = require('../core/MediumColors');

var _MediumColors2 = _interopRequireDefault(_MediumColors);

var _NormalColors = require('../core/NormalColors');

var _NormalColors2 = _interopRequireDefault(_NormalColors);

var _underscore = require('../utils/underscore');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _Styles = require('../utils/Styles');

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _colors = require('HubStyleTokens/colors');

var _misc = require('HubStyleTokens/misc');

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  // These do not come from the sketch file
  default: 'tag-default private-tag--default',
  primary: 'tag-primary',
  info: 'tag-info private-tag--info',

  success: 'tag-success private-tag--success',
  warning: 'tag-warning private-tag--warning',
  danger: 'tag-danger private-tag--danger',

  calypso: '',
  sorbet: '',
  lorax: '',
  marigold: '',
  'candy-apple': '',
  norman: '',
  thunderdome: '',
  oz: '',
  olaf: ''
};

var STATUS_ALIAS_MAP = {
  disabled: 'default',
  paused: 'default',
  draft: 'default',
  active: 'success',
  sent: 'success',
  published: 'success',
  inReview: 'warning',
  scheduled: 'warning',
  removed: 'danger',
  cancelled: 'danger',
  error: 'danger'
};

var USE_COLOR_ALIAS_MAP = {
  // defaults
  disabled: 'default',
  paused: 'default',
  draft: 'default',
  primary: 'default',
  // oz
  success: 'oz',
  active: 'oz',
  sent: 'oz',
  published: 'oz',
  // marigold
  warning: 'marigold',
  inReview: 'marigold',
  scheduled: 'marigold',
  // cand-apple
  danger: 'candy-apple',
  removed: 'candy-apple',
  cancelled: 'candy-apple',
  error: 'candy-apple',
  // calypso
  info: 'calypso'
};

var TAG_BACKGROUND_COLORS = _extends({}, _LightColors2.default, {
  default: _colors.GYPSUM
});
var TAG_IS_BORDERED_BORDER_COLORS = _extends({}, _MediumColors2.default, {
  default: _colors.EERIE
});
var TAG_BORDER_COLORS = _extends({}, _NormalColors2.default, {
  default: _colors.EERIE
});

var getBackgroundColor = function getBackgroundColor(use) {
  return TAG_BACKGROUND_COLORS[use] != null ? TAG_BACKGROUND_COLORS[use] : _colors.EERIE;
};

var getBorderColor = function getBorderColor(use, bordered) {
  if (bordered && TAG_IS_BORDERED_BORDER_COLORS[use] != null) {
    return TAG_IS_BORDERED_BORDER_COLORS[use];
  } else if (TAG_BORDER_COLORS[use] != null) {
    return TAG_BORDER_COLORS[use];
  }
  return 'transparent';
};

var getInlineStyles = function getInlineStyles(inline) {
  return inline ? '\n        margin: 0 4px;\n        vertical-align: middle;\n      ' : null;
};

var getCloseablePadding = function getCloseablePadding(closeable) {
  return closeable ? '\n        padding-right: 28px !important;\n      ' : null;
};

var renderContents = function renderContents(href, target, onClick, truncatedChildren) {
  var buttonClassName = 'private-tag__link';
  if (href) {
    return _react2.default.createElement(
      StyledLink,
      {
        className: buttonClassName,
        href: href,
        target: target,
        use: 'on-bright'
      },
      truncatedChildren
    );
  } else if (onClick) {
    return _react2.default.createElement(
      LinkStyledClickable,
      { className: buttonClassName, onClick: onClick },
      truncatedChildren
    );
  }

  return _react2.default.createElement(
    ContentWrapper,
    { className: 'private-tag__content-wrapper' },
    truncatedChildren
  );
};

var Tag = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__Tag'
})(['font-size:', ';background-color:', ';border:1px solid ', ';color:', ';line-height:', ';padding:', ' ', ';', ' position:relative;cursor:inherit;display:inline-flex;font-weight:', ';max-width:100%;overflow:hidden;user-select:none;vertical-align:8px;> * + *{margin-left:', ';}& + .private-tag{margin-left:', ';}a,a:hover,a:active{color:inherit;}', ''], _sizes.TAG_FONT_SIZE, function (props) {
  return getBackgroundColor(props.computedUse);
}, function (props) {
  return getBorderColor(props.computedUse, props._bordered);
}, function (props) {
  return props.computedUse === 'olaf' ? _colors.OLAF : _theme.BASE_FONT_COLOR;
}, (0, _Styles.toPx)(parseInt(_sizes.TAG_HEIGHT, 10) - 2), _sizes.TAG_PADDING_Y, _sizes.TAG_PADDING_X, function (props) {
  return getCloseablePadding(props.closeable);
}, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, _sizes.TAG_ICON_SPACING_X, function (_ref) {
  var inline = _ref.inline;
  return inline ? null : _sizes.BASE_SPACING_X;
}, function (props) {
  return getInlineStyles(props.inline);
});

var FlexWrapper = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__FlexWrapper'
})(['display:inline-flex;max-width:100%;vertical-align:top;']);

var ContentWrapper = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__ContentWrapper'
})(['overflow:hidden;']);

var StyledCloseButton = (0, _styledComponents2.default)(_UICloseButton2.default).withConfig({
  displayName: 'UITag__StyledCloseButton'
})(['bottom:0;color:currentColor;margin-bottom:auto;margin-top:auto;position:absolute;right:6px;top:0;transform:scale(0.5);']);

var StyledLink = (0, _styledComponents2.default)(_UILink2.default).withConfig({
  displayName: 'UITag__StyledLink'
})(['overflow:hidden;']);
StyledLink.displayName = 'StyledUILink';

var LinkStyledClickable = (0, _styledComponents2.default)(_UIClickable2.default).withConfig({
  displayName: 'UITag__LinkStyledClickable'
})(['&&{font-weight:', ';overflow:hidden;text-decoration:underline;}'], _misc.WEB_FONT_MEDIUM_WEIGHT);
LinkStyledClickable.displayName = 'StyledUIClickable';

function UITag(props) {
  var _avatar = props._avatar,
      _bordered = props._bordered,
      children = props.children,
      className = props.className,
      closeable = props.closeable,
      href = props.href,
      id = props.id,
      inline = props.inline,
      multiline = props.multiline,
      onClick = props.onClick,
      onCloseClick = props.onCloseClick,
      _onCloseMouseDown = props._onCloseMouseDown,
      target = props.target,
      truncateStringProps = props.truncateStringProps,
      use = props.use,
      rest = _objectWithoutProperties(props, ['_avatar', '_bordered', 'children', 'className', 'closeable', 'href', 'id', 'inline', 'multiline', 'onClick', 'onCloseClick', '_onCloseMouseDown', 'target', 'truncateStringProps', 'use']);

  var idRef = (0, _react.useRef)((0, _underscore.uniqueId)('tag-'));
  var computedId = id || idRef.current;

  var truncatedChildren = multiline ? children : _react2.default.createElement(
    _UITruncateString2.default,
    _extends({ useFlex: true }, truncateStringProps),
    children
  );

  return _react2.default.createElement(
    Tag,
    _extends({
      className: (0, _classnames2.default)('tag', 'private-tag', className, USE_CLASSES[STATUS_ALIAS_MAP[use] || use], {
        'private-tag--bordered': _bordered,
        'private-tag--has-close': closeable,
        'private-tag--inline': inline
      }),
      'data-component-name': 'UITag',
      id: computedId,
      computedUse: USE_COLOR_ALIAS_MAP[use] || use,
      _bordered: _bordered,
      closeable: closeable,
      inline: inline
    }, rest),
    _react2.default.createElement(
      FlexWrapper,
      { className: 'private-tag__flex-wrapper' },
      _avatar,
      renderContents(href, target, onClick, truncatedChildren)
    ),
    closeable && _react2.default.createElement(StyledCloseButton, {
      'aria-describedby': computedId,
      className: 'private-tag__close',
      onClick: onCloseClick,
      onMouseDown: _onCloseMouseDown
    })
  );
}

UITag.propTypes = {
  children: _propTypes2.default.any,
  closeable: _propTypes2.default.bool.isRequired,
  href: _propTypes2.default.string,
  target: _propTypes2.default.string,
  inline: _propTypes2.default.bool.isRequired,
  multiline: _propTypes2.default.bool.isRequired,
  onCloseClick: _propTypes2.default.func,
  truncateStringProps: (0, _passthroughProps2.default)(_UITruncateString2.default),
  use: _propTypes2.default.oneOf(Object.keys(USE_CLASSES).concat(Object.keys(STATUS_ALIAS_MAP))).isRequired,
  _avatar: _propTypes2.default.node, // for UIAvatarTag
  _bordered: _propTypes2.default.bool, // for MultiSelect
  _onCloseMouseDown: _propTypes2.default.func // for MultiSelectValue
};

UITag.defaultProps = {
  _bordered: false,
  closeable: false,
  inline: false,
  multiline: false,
  use: 'default'
};

UITag.displayName = 'UITag';

UITag.STATUS_ALIAS_MAP = STATUS_ALIAS_MAP;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tag/UITag.js
// module id = 513
// module chunks = 177